/* unplugin-vue-components disabled */import script from "./AddSalesmanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSalesmanModal.vue?vue&type=script&setup=true&lang=js"

import "./AddSalesmanModal.vue?vue&type=style&index=0&id=db574360&lang=css"

const __exports__ = script;

export default __exports__